module.exports = __webpack_public_path__ + "static/media/archive.978f1f93.svg";